"use client";

import { memo, Suspense } from "react";
import ActivityChart from "../../../../ActivityChart";
import type { ActivityDataPoint } from "../../../../ActivityChart/types";
import type { DisplayMode } from "../types";
import { ChartSkeleton } from "../../ui/ChartSkeleton";

interface MinutesChartProps {
  data: ActivityDataPoint[];
  normalThreshold: number;
  height?: number;
  displayMode?: DisplayMode;
}

/**
 * Компонент для отображения графика активности по минутам
 * Оборачивает ActivityChart с предустановленными параметрами
 */
export const MinutesChart = memo(function MinutesChart({
  data,
  normalThreshold,
  height = 150,
  displayMode = "minutes"
}: MinutesChartProps) {
  return (
    <Suspense fallback={<ChartSkeleton />}>
      <ActivityChart
        height={height}
        data={data}
        normalThreshold={normalThreshold}
        showLegend={false}
        withCard={false}
        chartType="area"
        hideYAxis={true}
        showFirstMinute={true}
        displayMode={displayMode}
      />
    </Suspense>
  );
});